import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Radar } from 'react-chartjs-2';

export class RadarChart extends Component {
  static propTypes = {
    labels: PropTypes.arrayOf(PropTypes.string),
    dataPoints: PropTypes.arrayOf(PropTypes.number),
  };

  render() {
    const { labels, dataPoints } = this.props;

    const data = dataPoints;

    const dataObj = {
      labels,
      datasets: [
        {
          fill: true,
          backgroundColor: 'rgba(179,181,198,0.2)',
          borderColor: '#f9d705',
          pointBackgroundColor: '#f9d705',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(179,181,198,1)',
          data,
        },
      ],
    };

    // decimel fix https://stackoverflow.com/questions/37699485/skip-decimal-points-on-y-axis-in-chartjs

    const options = {
      legend: {
        display: false,
      },
      responsive: true,
      maintainAspectRatio: true,
      layout: {
        padding: {
          left: 5,
          right: 0,
          top: 0,
          bottom: 0,
        },
      },
      gridLines: {
        display: false,
      },
      scale: {
        ticks: {
          beginAtZero: true,
          min: 0,
          max: 5,
        },
        angleLines: {
          display: false,
        },
        gridLines: {
          color: '#252e4a',
        },
      },
    };

    return <Radar data={dataObj} options={options} />;
  }
}

export default RadarChart;



// WEBPACK FOOTER //
// ./src/ui/common/charts/radar-chart/index.js